import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Layout, Menu, MenuProps, Drawer, Space } from 'antd';
import Paths, { Path } from 'routes';
import SubMenu from 'antd/lib/menu/SubMenu';
import { PurpleMobileLogo, UserInfo } from 'components/molecules';
import useStore from 'store';
import { MenuOutlined } from '@ant-design/icons';

export interface HeaderProps {}

const Header = (props: HeaderProps): React.ReactElement => {
  /* ======================================================
   * stores
   * ====================================================== */
  const auth = useStore((state) => state.auth);  

  /* ======================================================
   * variables
   * ====================================================== */
  const { paths } = Paths;

  /* ======================================================
   * states
   * ====================================================== */
  const [selected, setSelected] = useState('');
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const splitPath = location.pathname.split('/');
    if (splitPath.length > 3) setSelected(`${splitPath[1]}/${splitPath[2]}/${splitPath[3]}`);
    else if (splitPath.length > 2) setSelected(`${splitPath[1]}/${splitPath[2]}`);
    else if (splitPath[0] === 'mypage') setSelected('/');
    else setSelected(splitPath[1] || '/');

  }, [location.pathname]);

  /* ======================================================
   * events
   * ====================================================== */
  const onClick: MenuProps['onClick'] = (e) => {
    setSelected(e.key);
  };

  /* ======================================================
   * render items
   * ====================================================== */
  const makeMenu = (paths: Path[]) => {
    return paths.map((p) => {
      if (!p.isShow) return;
      if (!!p.rule && auth.login && auth.login.div && !(auth.login.div.split(',').some(item => { 
        return !!p.rule && p.rule.includes(item)
      }))) return;

      if (p.children) {
        return (
          <SubMenu key={p.key} title={p.title}>
            {makeMenu(p.children)}
          </SubMenu>
        );
      } else {
        return (
          <Menu.Item key={p.key}>
            <NavLink to={p.key}>{p.title}</NavLink>
          </Menu.Item>
        );
      }
    });
  };
  const MenuItems = makeMenu(paths);
  return (
    <Layout.Header className="header-container-mobile">
      <div className="header">
        <Space>
          <MenuOutlined style={{fontSize:24}} onClick={() => {setOpenMenu(true);}}/>
          <PurpleMobileLogo />
        </Space>
        <UserInfo />        
      </div>
      <Drawer 
        open={openMenu} 
        onClose={() => {setOpenMenu(false);}}
        closable={true}
        placement='left'
      >
        <Menu 
          theme="light" 
          selectedKeys={[selected]} 
          mode="inline" 
          style={{border:"none"}}          
          onClick={() => {onClick; setOpenMenu(false);}}>
          {MenuItems}
        </Menu>
      </Drawer>
    </Layout.Header>
  );
};

export default Header;
